/**
 * Converts a .NET date/time format string into an equivelant (or compatible?) Element UI format string
 * @param format The date/time format string
 */
export function convertToElementDateFormat(format: string): string {
	if (format) {
		format = format.replace(/tt/g, 'A');
	}
	return format;
}
